export default "<div class=\"survey-container contentcontainer codecontainer\">\n    <div id=\"surveyElement\"></div>\n</div>"